module.exports = "https://coursera_assets.s3.amazonaws.com/images/6a995faf5ffdd17d0e78665f8676374b.png";